import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import usePrevious from '../../../hooks/usePrevious';
import { useEmbeddedCommentClickListener } from '../hooks/useEmbeddedCommentClickListener';
import { useToggleOpenPopover } from '../hooks/useToggleOpenPopover';
import { useEmbeddedCommentHandlers } from '../hooks/useEmbeddedCommentHandlers';
import useWindowScrollListener from '../../../hooks/useWindowScrollListener';
import { jsx as _jsx } from "react/jsx-runtime";
export function useControlledEmbeddedCommentPopover(t0) {
  "use memo";

  const $ = _c(30);
  const {
    moduleId,
    description,
    collaborationSidebarState,
    onUpdateCollaborationSidebarState,
    isOpen,
    onOpenChange,
    popoverPlacement: t1,
    nodeRef
  } = t0;
  const popoverPlacement = t1 === undefined ? "top" : t1;
  const {
    isEmbeddedPopoverOpen
  } = collaborationSidebarState;
  const prevIsOpen = usePrevious(isOpen);
  const prevIsEmbeddedPopoverOpen = usePrevious(isEmbeddedPopoverOpen);
  const [childElement, setChildElement] = useState(null);
  let t2;
  let t3;
  if ($[0] !== nodeRef) {
    t2 = () => {
      if (nodeRef !== null && nodeRef !== void 0 && nodeRef.current) {
        setChildElement(nodeRef.current);
        return;
      }
    };
    t3 = [nodeRef];
    $[0] = nodeRef;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== childElement || $[4] !== description || $[5] !== moduleId || $[6] !== onUpdateCollaborationSidebarState || $[7] !== popoverPlacement) {
    t4 = {
      embeddedCommentWrapper: childElement,
      onUpdateCollaborationSidebarState,
      moduleId,
      metaDescription: description,
      placement: popoverPlacement
    };
    $[3] = childElement;
    $[4] = description;
    $[5] = moduleId;
    $[6] = onUpdateCollaborationSidebarState;
    $[7] = popoverPlacement;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const toggleOpenPopover = useToggleOpenPopover(t4);
  let t5;
  let t6;
  if ($[9] !== isOpen || $[10] !== prevIsOpen || $[11] !== toggleOpenPopover) {
    t5 = () => {
      if (isOpen !== prevIsOpen) {
        toggleOpenPopover(isOpen);
      }
    };
    t6 = [isOpen, prevIsOpen, toggleOpenPopover];
    $[9] = isOpen;
    $[10] = prevIsOpen;
    $[11] = toggleOpenPopover;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[14] !== isEmbeddedPopoverOpen || $[15] !== onOpenChange || $[16] !== prevIsEmbeddedPopoverOpen) {
    t7 = () => {
      if (!isEmbeddedPopoverOpen && prevIsEmbeddedPopoverOpen && onOpenChange) {
        onOpenChange(isEmbeddedPopoverOpen);
      }
    };
    t8 = [onOpenChange, isEmbeddedPopoverOpen, prevIsEmbeddedPopoverOpen];
    $[14] = isEmbeddedPopoverOpen;
    $[15] = onOpenChange;
    $[16] = prevIsEmbeddedPopoverOpen;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  useEffect(t7, t8);
  let t9;
  if ($[19] !== childElement || $[20] !== onUpdateCollaborationSidebarState || $[21] !== popoverPlacement) {
    t9 = {
      popoverPlacement,
      embeddedCommentWrapper: childElement,
      onUpdateCollaborationSidebarState
    };
    $[19] = childElement;
    $[20] = onUpdateCollaborationSidebarState;
    $[21] = popoverPlacement;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const {
    updateEmbeddedCommentCoordinates
  } = useEmbeddedCommentHandlers(t9);
  let t10;
  if ($[23] !== isOpen || $[24] !== updateEmbeddedCommentCoordinates) {
    t10 = {
      listenToScroll: isOpen,
      onScroll: updateEmbeddedCommentCoordinates,
      useCapture: true
    };
    $[23] = isOpen;
    $[24] = updateEmbeddedCommentCoordinates;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  useWindowScrollListener(t10);
  let t11;
  if ($[26] !== isOpen || $[27] !== onUpdateCollaborationSidebarState || $[28] !== prevIsOpen) {
    t11 = {
      onUpdateCollaborationSidebarState,
      isOpen,
      prevIsOpen
    };
    $[26] = isOpen;
    $[27] = onUpdateCollaborationSidebarState;
    $[28] = prevIsOpen;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  useEmbeddedCommentClickListener(t11);
}
export default function ControlledEmbeddedCommentPopover(props) {
  var _props$nodeRef;
  const ref = useRef(null);
  useControlledEmbeddedCommentPopover(Object.assign({}, props, {
    nodeRef: (_props$nodeRef = props.nodeRef) !== null && _props$nodeRef !== void 0 ? _props$nodeRef : ref
  }));
  return /*#__PURE__*/_jsx("span", {
    ref: ref,
    children: props.children
  });
}